import { supabase } from '../client';

export interface CandidateTag {
  id: string;
  org_id: string;
  candidate_id: string;
  tag: string;
  created_by: string | null;
  created_at: string;
}

export const candidateTagService = {
  async listByCandidate(candidateId: string): Promise<CandidateTag[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_candidate_tags')
      .select('*')
      .eq('candidate_id', candidateId)
      .order('tag');
    if (error) throw error;
    return (data ?? []) as CandidateTag[];
  },

  async listByOrg(orgId: string): Promise<{ tag: string; count: number }[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_candidate_tags')
      .select('tag')
      .eq('org_id', orgId);
    if (error) throw error;
    const freq: Record<string, number> = {};
    for (const row of (data ?? []) as { tag: string }[]) {
      freq[row.tag] = (freq[row.tag] ?? 0) + 1;
    }
    return Object.entries(freq)
      .map(([tag, count]) => ({ tag, count }))
      .sort((a, b) => b.count - a.count);
  },

  async addTag(orgId: string, candidateId: string, tag: string, createdBy?: string): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_candidate_tags')
      .upsert(
        { org_id: orgId, candidate_id: candidateId, tag: tag.trim().toLowerCase(), created_by: createdBy ?? null },
        { onConflict: 'org_id,candidate_id,tag', ignoreDuplicates: true }
      );
    if (error) throw error;
  },

  async removeTag(orgId: string, candidateId: string, tag: string): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_candidate_tags')
      .delete()
      .eq('org_id', orgId)
      .eq('candidate_id', candidateId)
      .eq('tag', tag);
    if (error) throw error;
  },

  async bulkAddTag(orgId: string, candidateIds: string[], tag: string, createdBy?: string): Promise<void> {
    const rows = candidateIds.map((id) => ({
      org_id: orgId,
      candidate_id: id,
      tag: tag.trim().toLowerCase(),
      created_by: createdBy ?? null,
    }));
    const { error } = await supabase
      .from('ggj_b2b_candidate_tags')
      .upsert(rows, { onConflict: 'org_id,candidate_id,tag', ignoreDuplicates: true });
    if (error) throw error;
  },
};
